/**
 *
 * BackButton
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import qs from 'qs';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { makeSelectClientLanding } from 'containers/ClientLanding/selectors';
import _get from 'lodash/get';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { getLogos, getLogoComponent } from 'components/NavBarMenu/utils';

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: 'none',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('600')]: {
      justifyContent: 'center',
    },
  },
  linkText: {
    alignItems: 'center',
    textTransform: 'none',
    color: ({ color }) =>
      color ? theme.palette.text.secondary : theme.palette.primary.contrastText,
    ...theme.typography.overline,
  },
  icon: {
    height: '0.875em',
    width: '0.875em',
    color: ({ color }) =>
      color ? theme.palette.text.secondary : theme.palette.primary.contrastText,
  },
  backBtn: {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
  wrapperClass: {
    position: 'relative',
    width: '100%',
    height: 22,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  mobileLogoContainer: {
    justifyContent: 'center',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '& > a': {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
    },
  },
  clientLogo: {
    maxHeight: 40,
    marginTop: 10,
    maxWidth: '45%',
  },
  logo: {
    maxHeight: 40,
    maxWidth: '45%',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
}));

function BackButton({ to, label, altStyle }) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const clientDetails = useSelector(makeSelectClientDetails());
  const clientLanding = useSelector(makeSelectClientLanding());

  const { logos, logosUrl } = getLogos(clientDetails, clientLanding);
  const firstLogo = logos[0];
  const firstLogoUrl = logosUrl[0];
  const secondLogo = logos[1];
  const secondLogoUrl = logosUrl[1];

  const FirstLogoComponent = getLogoComponent({
    url: firstLogoUrl,
    image: <img src={firstLogo} alt="CredibleMind" className={classes.logo} />,
    shouldRedirectOnClientUrl: _get(
      clientDetails,
      'metadata.shouldRedirectOnClientUrl',
    ),
  });
  const SecondLogoComponent = getLogoComponent({
    url: secondLogoUrl,
    image: (
      <img
        src={secondLogo}
        alt={clientDetails.name}
        className={classes.clientLogo}
      />
    ),
    shouldRedirectOnClientUrl: _get(
      clientDetails,
      'metadata.shouldRedirectOnClientUrl',
    ),
  });

  const onClick = () => {
    if (to) history.push(to);
    else {
      const params = qs.parse(location.search.slice(1));
      if (params.redirect) history.push(params.redirect);
      else history.push('/');
    }
  };

  if (altStyle && _get(clientDetails, 'signIn') === 'Require') return null;

  return (
    <Grid item xs={12}>
      <Grid container className={classes.wrapperClass}>
        <div className={classes.backBtn}>
          {_get(clientDetails, 'signIn') !== 'Require' && (
            <ButtonBase
              disableRipple
              className={classes.link}
              onClick={onClick}
            >
              <ChevronLeftIcon className={classes.icon} />
              <Typography className={classes.linkText}>{label}</Typography>
            </ButtonBase>
          )}
        </div>
        {!altStyle && (
          <Hidden mdUp>
            <div className={classes.mobileLogoContainer}>
              {FirstLogoComponent}
              {secondLogo && SecondLogoComponent}
            </div>
          </Hidden>
        )}
      </Grid>
    </Grid>
  );
}

BackButton.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
  altStyle: PropTypes.bool,
};

export default BackButton;
